import { fromPairs } from "lodash";
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App.js";
import { Provider } from "react-redux";
import { store } from "./redux/store/store";

require("./index.html");
require("./scss/index.scss");

ReactDOM.render(
  <Provider store={store}>
    <App> </App>
  </Provider>,

  document.getElementById("app"),
);



// WEBPACK FOOTER //
// ./frontend/app.js